import { getTradeInOrder, postTradeInOrderStatus, updateTradeInOrders } from './getTradeInOrders'
import { getTradeInOrders } from './getTradeInOrders'

export const tradeInResources = {
  getTradeInOrders,
  getTradeInOrder,
  postTradeInOrderStatus,
  updateTradeInOrders,
}

export type TradeInOrder = Awaited<ReturnType<typeof getTradeInOrder>>
export type TradeInOrders = Awaited<ReturnType<typeof getTradeInOrders>>['orders'][number]
export type TradeInOrderCounter = Awaited<ReturnType<typeof getTradeInOrders>>['orderCounter']
